import { useSettingSignupAppRouterMigration } from "@faire/retailer-visitor-shared/settings/useSettingSignupAppRouterMigration";
import { parseQueryParams } from "@faire/web--source/common/query-params/parseQueryParams";
import { useLocation } from "react-router-dom";

export const useIsAppRouterMigration = () => {
  const isAppRouterMigration = useSettingSignupAppRouterMigration();
  const location = useLocation();
  const isAppRouterMigrationParam = parseQueryParams(location.search).get(
    "appRouter"
  );

  return isAppRouterMigrationParam === "1" || isAppRouterMigration;
};
